import { Button, appConstants } from 'mypages-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'components/Input/Input';
import styles from './ChangePassword.module.scss';
import PageTemplate from './PageTemplate';

export type EnterTokenProps = {
  validateSmsToken: (smsToken: string) => void;
  phone: string;
  isLoading: boolean;
  error: string;
  resetError: () => void;
};

const EnterToken = ({ validateSmsToken, phone, isLoading, error, resetError }: EnterTokenProps) => {
  const { t } = useTranslation();
  const [token, setToken] = useState('');

  const { SMS_TOKEN_LENGTH } = appConstants;

  const onSubmitToken = () => {
    validateSmsToken(token);
  };

  const onTokenChange = (newToken: string) => {
    setToken(newToken);
    resetError();
  };

  return (
    <PageTemplate>
      <h1 className={styles.title}>{t('MPL_FORGOT_NEW_PHONE_VERIFICATION_TITLE')}</h1>
      <p className={styles.text}>{t('MPL_CHANGE_PW_VERIFICATION_CODE_SENT', { phone })}</p>
      <Input
        type="text"
        placeholder={t(`MPL_ENTER_CODE_PHONE`)}
        onChange={onTokenChange}
        focus
        value={token}
        icon="icon-close"
        minLength={SMS_TOKEN_LENGTH}
        maxLength={SMS_TOKEN_LENGTH}
        onIconClick={() => {
          onTokenChange('');
        }}
        autoComplete="one-time-code"
        inputMode="numeric"
        hasError={Boolean(error)}
        errorMessage={error}
        dataTestId="sms-token-input"
      />
      <Button
        text={t('MPL_SUBMIT_CODE')}
        className={styles.confirmButton}
        white
        disabled={token.length !== SMS_TOKEN_LENGTH || isLoading}
        isLoading={isLoading}
        onClick={onSubmitToken}
        dataTestId="submit-validate-token"
      />
    </PageTemplate>
  );
};
export default EnterToken;
